// extracted by mini-css-extract-plugin
export default {"content":"VetifyModal_content__X2lFb","modal":"VetifyModal_modal__lURuZ"};